import React from "react";
import styles from "./ThemeInfo.module.css";
import { FaHeart, FaSeedling } from "react-icons/fa";
import { FaBowlFood, FaHelmetSafety } from "react-icons/fa6";

const ThemeInfo = () => {
  const features = [
    {
      title: "End Hunger",
      description: "A goal to eliminate hunger worldwide.",
      icon: <FaBowlFood />,
    },
    {
      title: "Promote Sustainable Agriculture",
      description: "Encouraging practices that support sustainable farming.",
      icon: <FaSeedling />,
    },
    {
      title: "Improve Nutrition",
      description: "Focusing on better nutrition for all.",
      icon: <FaHeart />,
    },
    {
      title: "Achieve Food Security",
      description: "Ensuring access to sufficient food for everyone.",
      icon: <FaHelmetSafety />,
    },
  ];
  return (
    <section className={styles.whyPartner} id="theme-info">
      <div className={styles.container}>
        <h2 data-aos="fade-up">
          2024-2025 Theme:{" "}
          <span className={styles.highlightTheme}>Food for All</span>
        </h2>
        <p className={styles.subtitle}>
          The mission this year is to build a robot/project that supports the
          way we grow, share, and consume food. Your project should focus around
          at least one of the following aspects of the Goals 2 of sustainable
          development.
        </p>
        <div className={styles.features}>
          {features.map((feature, index) => (
            <div key={index} className={styles.feature}>
              <div className={styles.iconWrapper}>{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ThemeInfo;
